import React, { FC, ReactElement, useContext } from 'react';
import { Box, Image } from 'grommet';
import styled, { css } from 'styled-components';
import { normalizeColor } from 'grommet/utils';
import { ThemeModeContext } from '@pentester.com/grommet-theme';

const LeftCircle = styled.div`
  ${({ theme }) => css`
    position: fixed;
    background-color: ${normalizeColor(`status-critical`, theme)};
    left: 0;
    bottom: 0;
    opacity: 0.25;
    border-radius: 100%;
    height: 5vw;
    width: 5vw;
    z-index: 0;
    max-height: 100px;
    max-width: 100px;
    box-shadow: 0 0 120px 100px ${normalizeColor(`status-critical`, theme)};
  `}
`;

const RightCircle = styled.div`
  ${({ theme }) => css`
    position: fixed;
    background-color: ${normalizeColor(`brand`, theme)};
    top: -20px;
    right: -20px;
    opacity: 0.35;
    z-index: 0;
    border-radius: 100%;
    height: 10vw;
    width: 10vw;
    max-height: 50px;
    max-width: 50px;
    box-shadow: 0 0 40px 40px ${normalizeColor(`brand`, theme)};
  `}
`;

export const DashboardVideo: FC = (): ReactElement => {
  const { mode } = useContext(ThemeModeContext);

  return (
    <Box animation="slideLeft" alignSelf="center">
      <LeftCircle />
      <Box height={{ max: `medium` }} width={{ max: `large` }}>
        <Image
          style={{ zIndex: 1, borderRadius: `12px` }}
          src={
            mode === `light`
              ? `https://storage.googleapis.com/pentester-demo-website/lightmode.gif`
              : `https://storage.googleapis.com/pentester-demo-website/darkmode.gif`
          }
          fallback={
            mode === `light`
              ? `/img/pentester-overview-light.png`
              : `/img/pentester-overview-dark.png`
          }
        />
      </Box>
      <RightCircle />
    </Box>
  );
};
